module.exports = __webpack_public_path__ + "static/media/notification-icon-restaurant.abfad581.svg";